module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAKCAYAAAAtradTAAAAAXNSR0IArs4c6QAAARBJREFUOE/l1b9Kw1AUx/HvqbGmFAmipRTpEN/Ch3ApTqK7Lg7Sgj6BCOLgIu7iJF18CJ9CM5QSSq0SpCbW2xwpruYqJYLFOx7un89wzu9KONAmwh5Q4+sVSoHj+Jkr35ckY8/U5SBQt7TEtqYc2QwoFxI+6T3gA5LxohaEu+GIxlpVelOrMg4+9LRaLtJOlXWbAQgm2BhwsxDOHERDOue3bAUduu5CftzkDfw6q/sbXHtl6mZsvTuZYF+Bkg3bjzCnN4SDF0zRyQ87MrC8iNPcpFbxcL7Bxj/CPkZw1oZ+BPM5Yt8NVDw4aMCKB/8P+5faYKYGbDaiSz6jqwXsZgWyCF2Ek1/+FHY05dBmUOHyA2HtqL1VDYFbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/editor-icon/zxh.png
// module id = CXWO
// module chunks = 3